import {NgModule} from '@angular/core';
import { RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './Services/auth-guard.service';
import {UnsavedChangesGuard} from './Guards/unsaved-changes.guard';
import {HomeComponent} from './Components/home/home.component';
import {LoginComponent} from './Components/login/login.component';
import {ForgotPasswordComponent} from './Components/forgot-password/forgot-password.component';
import {EntityListComponent} from './Components/Entity/entity-list/entity-list.component';
import {EntityFormComponent} from './Components/Entity/entity-form/entity-form.component';
import {AppLayoutComponent} from './Layouts/app-layout.component';
import {LoginLayoutComponent} from './Layouts/login-layout.component';
import {TransactionLayoutComponent} from './Layouts/transaction-layout.component';
import {BankListComponent} from './Components/admin/banks/bank-list/bank-list.component';
import {ItemListComponent} from './Components/admin/item/item-list/item-list.component';
import {ItemFormComponent} from './Components/admin/item/item-form/item-form.component';
import {BankFormComponent} from './Components/admin/banks/bank-form/bank-form.component';
import {BudgetFormComponent} from './Components/admin/budget/budget-form/budget-form.component';
import {BudgetListComponent} from './Components/admin/budget/budget-list/budget-list.component';
import {LocationListComponent} from './Components/admin/location/location-list/location-list.component';
import {CompanyListComponent} from './Components/admin/company/company-list/company-list.component';
import {CurrencyListComponent} from './Components/admin/currency/currency-list/currency-list.component';
import {AccountListComponent} from './Components/admin/account/account-list/account-list.component';
import {AccountImportComponent} from './Components/admin/account/account-import/account-import.component';
import {GlImportComponent} from './Components/transactions/gl-import/gl-import.component';
import {EntityTypeListComponent} from './Components/admin/entity-type/entity-type-list/entity-type-list.component';
import {AccountFormComponent} from './Components/admin/account/account-form/account-form.component';
import {AccountSubtotalListComponent} from './Components/admin/account-subtotal/account-subtotal-list/account-subtotal-list.component';
import {CheckStockListComponent} from './Components/admin/check-stock/check-stock-list/check-stock-list.component';
import {CheckStockFormComponent} from './Components/admin/check-stock/check-stock-form/check-stock-form.component';
import {CurrencyRateListComponent} from './Components/admin/currency-rate/currency-rate-list/currency-rate-list.component';
import {CurrencyRateFormComponent} from './Components/admin/currency-rate/currency-rate-form/currency-rate-form.component';
import {EntityAccessListComponent} from './Components/admin/entity-access/entity-access-list/entity-access-list.component';
import {EntityAccessFormComponent} from './Components/admin/entity-access/entity-access-form/entity-access-form.component';
import {LocationGroupListComponent} from './Components/admin/location-group/location-group-list/location-group-list.component';
import {LocationGroupFormComponent} from './Components/admin/location-group/location-group-form/location-group-form.component';
import {SalespersonListComponent} from './Components/admin/salesperson/salesperson-list/salesperson-list.component';
import {SalespersonFormComponent} from './Components/admin/salesperson/salesperson-form/salesperson-form.component';
import {PaymentTypeListComponent} from './Components/admin/payment-type/payment-type-list/payment-type-list.component';
import {PaymentTypeFormComponent} from './Components/admin/payment-type/payment-type-form/payment-type-form.component';
import {StripeAdminListComponent} from './Components/admin/stripe-admin/stripe-admin-list/stripe-admin-list.component';
import {StripeAdminFormComponent} from './Components/admin/stripe-admin/stripe-admin-form/stripe-admin-form.component';
import {TaxListComponent} from './Components/admin/tax/tax-list/tax-list.component';
import {TaxFormComponent} from './Components/admin/tax/tax-form/tax-form.component';
import {TaxRateListComponent} from './Components/admin/tax-rate/tax-rate-list/tax-rate-list.component';
import {TaxRateFormComponent} from './Components/admin/tax-rate/tax-rate-form/tax-rate-form.component';
import {TermListComponent} from './Components/admin/term/term-list/term-list.component';
import {TermFormComponent} from './Components/admin/term/term-form/term-form.component';
import {LocationAccessListComponent} from './Components/admin/location-access/location-access-list/location-access-list.component';
import {LocationAccessFormComponent} from './Components/admin/location-access/location-access-form/location-access-form.component';
import {AccountMarginFormComponent} from './Components/admin/account-margin/account-margin-form/account-margin-form.component';
import {AccountMarginListComponent} from './Components/admin/account-margin/account-margin-list/account-margin-list.component';
import {AccountSubtotalFormComponent} from './Components/admin/account-subtotal/account-subtotal-form/account-subtotal-form.component';
import { BomListComponent } from './Components/inventory/bill-of-materials/bom-list/bom-list.component';
import { CountListComponent } from './Components/inventory/count/count-list/count-list.component';
import { TransferListComponent } from './Components/inventory/transfer/transfer-list/transfer-list.component';
import { AssemblyFormComponent } from './Components/inventory/assembly/assembly-form/assembly-form.component';
import { AssemblyListComponent } from './Components/inventory/assembly/assembly-list/assembly-list.component';
import { BomFormComponent } from './Components/inventory/bill-of-materials/bom-form/bom-form.component';
import { CountFormComponent } from './Components/inventory/count/count-form/count-form.component';
import { TransferFormComponent } from './Components/inventory/transfer/transfer-form/transfer-form.component';
import {InventoryDashboardComponent} from './Components/inventory/inventory-dashboard/inventory-dashboard.component';

import {CompanyAccessListComponent} from './Components/admin/company-access/company-access-list/company-access-list.component';
import {CompanyAccessFormComponent} from './Components/admin/company-access/company-access-form/company-access-form.component';
import {CurrencyFormComponent} from './Components/admin/currency/currency-form/currency-form.component';
import {UomListComponent} from './Components/admin/uom/uom-list/uom-list.component';
import {UomFormComponent} from './Components/admin/uom/uom-form/uom-form.component';
import {LocationFormComponent} from './Components/admin/location/location-form/location-form.component';

// fs report
import {BalanceSheetComponent} from './Components/Reports/financial/balance-sheet/balance-sheet.component';
import {ConsolidatedIncomeStatementComponent} from './Components/Reports/financial/consolidated-income-statement/consolidated-income-statement.component';
import {CompanyFormComponent} from './Components/admin/company/company-form/company-form.component';
import {MarginReportComponent} from './Components/Reports/financial/margin-report/margin-report.component';
import {TrialBalanceComponent} from './Components/Reports/financial/trial-balance/trial-balance.component';

// misc transaction-reports
import {TransactionDetailComponent} from './Components/Reports/transaction-reports/transaction-detail/transaction-detail.component';
import {AuditTrailViewerFormComponent} from './Components/admin/audit-trail-viewer/audit-trail-viewer-form/audit-trail-viewer-form.component';
import {AgingComponent} from './Components/Reports/transaction-reports/aging/aging.component';
import {InvoicesComponent} from './Components/Reports/transaction-reports/invoices/invoices.component';
import {PaymentsComponent} from './Components/Reports/transaction-reports/payments/payments.component';
import {
  StripeTransactionDetailComponent
} from './Components/Reports/transaction-reports/stripe-transaction-detail/stripe-transaction-detail.component';
import {CheckRegisterComponent} from './Components/Reports/transaction-reports/check-register/check-register.component';
import {StatementsComponent} from './Components/Reports/transaction-reports/statements/statements.component';
import {TaxComponent} from './Components/Reports/transaction-reports/tax/tax.component';
import {EntityReconciliationComponent} from './Components/Reports/entity/entity-reconciliation/entity-reconciliation.component';

// inventory transaction-reports
import {AssemblyReportComponent} from './Components/Reports/inventory/reports/assembly-report/assembly-report.component';
import {BalanceReportComponent} from './Components/Reports/inventory/reports/balance-report/balance-report.component';
import {CountReportComponent} from './Components/Reports/inventory/reports/count-report/count-report.component';
import {TransferReportComponent} from './Components/Reports/inventory/reports/transfer-report/transfer-report.component';

// payroll transaction-reports
import {EmployeeDetailReportComponent} from './Components/Reports/payroll/reports/employee-detail-report/employee-detail-report.component';

import {CashFlowComponent} from './Components/Reports/financial/cash-flow/cash-flow.component';
import {IncomeStatementComponent} from './Components/Reports/financial/income-statement/income-statement.component';
import {InvoiceRecurringListComponent} from './Components/transactions/invoice-recurring-list/invoice-recurring-list.component';
import {InvoiceFormArComponent} from './Components/transactions/invoice-form-ar/invoice-form-ar.component';
import {InvoiceFormApComponent} from './Components/transactions/invoice-form-ap/invoice-form-ap.component';
import {InvoiceFormSoComponent} from './Components/transactions/invoice-form-so/invoice-form-so.component';
import {InvoiceListSoComponent} from './Components/transactions/invoice-list-so/invoice-list-so.component';
import {InvoiceFormPoComponent} from './Components/transactions/invoice-form-po/invoice-form-po.component';
import {InvoiceListPoComponent} from './Components/transactions/invoice-list-po/invoice-list-po.component';
import {InvoiceFormQuotePageComponent} from './Components/transactions/invoice-form-quote/invoice-form-quote.component';
import {InvoiceListQuoteComponent} from './Components/transactions/invoice-list-quote/invoice-list-quote.component';
import {InvoiceListArComponent} from './Components/transactions/invoice-list-ar/invoice-list-ar.component';
import {InvoiceListApComponent} from './Components/transactions/invoice-list-ap/invoice-list-ap.component';
import {PaymentListComponent} from './Components/transactions/payment-list/payment-list.component';
import {IssuePaymentsComponent} from './Components/transactions/issue-payments/issue-payments.component';
import {PaymentFormComponent} from './Components/transactions/payment-form/payment-form.component';
import {ReportingFieldListComponent} from './Components/admin/reporting-field/reporting-field-list/reporting-field-list.component';
import {ReportingFieldFormComponent} from './Components/admin/reporting-field/reporting-field-form/reporting-field-form.component';
import {ReportingFieldTypeListComponent} from './Components/admin/reporting-field-type/reporting-field-type-list/reporting-field-type-list.component';
import {ReportingFieldTypeFormComponent} from './Components/admin/reporting-field-type/reporting-field-type-form/reporting-field-type-form.component';
import {
  BankReconciliationListComponent
} from './Components/bank/bank-reconciliation/bank-reconciliation-list/bank-reconciliation-list.component';
import {
  BankReconciliationFormComponent
} from './Components/bank/bank-reconciliation/bank-reconciliation-form/bank-reconciliation-form.component';
import {BankImportWizardComponent} from './Components/bank/bank-import/bank-import-wizard/bank-import-wizard.component';
import {BankImportHistoryComponent} from './Components/bank/bank-import/bank-import-history/bank-import-history.component';
import {BankImportPageComponent} from './Components/bank/bank-import/bank-import-page/bank-import-page.component';
import {WorkOrdersFormComponent} from './Components/work-orders/work-orders-form/work-orders-form.component';
import {WorkOrdersListComponent} from './Components/work-orders/work-orders-list/work-orders-list.component';
import {WorkOrdersBillingComponent} from './Components/work-orders/work-orders-billing/work-orders-billing.component';
import {WorkOrdersDashboardComponent} from './Components/work-orders/work-orders-dashboard/work-orders-dashboard.component';
import {WorkOrdersScheduleComponent} from './Components/work-orders/work-orders-schedule/work-orders-schedule.component';
import {AssetListComponent} from './Components/work-orders/assets/asset-list/asset-list.component';
import {AssetFormComponent} from './Components/work-orders/assets/asset-form/asset-form.component';
import {AssetDetailComponent} from './Components/work-orders/assets/asset-detail/asset-detail.component';
import {PmScheduleListComponent} from './Components/work-orders/pm-schedules/pm-schedule-list/pm-schedule-list.component';
import {PmScheduleFormComponent} from './Components/work-orders/pm-schedules/pm-schedule-form/pm-schedule-form.component';
import {WoTypeListComponent} from './Components/work-orders/settings/wo-type-list/wo-type-list.component';
import {WoCategoryListComponent} from './Components/work-orders/settings/wo-category-list/wo-category-list.component';
import {
  WoUserBillingRateListComponent
} from './Components/work-orders/settings/wo-user-billing-rate-list/wo-user-billing-rate-list.component';
import {ChecklistTemplateListComponent} from './Components/work-orders/settings/checklist-template-list/checklist-template-list.component';
import {TimesheetListComponent} from './Components/timesheet/timesheet-list/timesheet-list.component';
import {TimesheetFormComponent} from './Components/timesheet/timesheet-form/timesheet-form.component';
import {TimesheetApprovalListComponent} from './Components/timesheet/timesheet-approval-list/timesheet-approval-list.component';
import {TimesheetApprovalFormComponent} from './Components/timesheet/timesheet-approval-form/timesheet-approval-form.component';

import {SysUserListComponent} from './Components/admin/sys-user/sys-user-list/sys-user-list.component';
import {CalendarComponent} from './Components/calendar/calendar/calendar.component';
import {SysUserFormComponent} from './Components/admin/sys-user/sys-user-form/sys-user-form.component';
import {UserProfileComponent} from './Components/admin/user-profile/user-profile.component';
import {StatisticalRecurringListComponent} from './Components/transactions/statistical-recurring-list/statistical-recurring-list.component';

import {EntryFormComponent} from './Components/transactions/entry-form/entry-form.component';
import {EntryListComponent} from './Components/transactions/entry-list/entry-list.component';
import EntryRecurringComponent from './Components/transactions/entry-recurring/entry-recurring.component';
import {StatisticalListComponent} from './Components/transactions/statistical-list/statistical-list.component';
import {StatisticalFormComponent} from './Components/transactions/statistical-form/statistical-form.component';
import {ItemCategoryListComponent} from './Components/admin/item-category/item-category-list/item-category-list.component';
import {ItemPricingListComponent} from './Components/admin/item-pricing/item-pricing-list/item-pricing-list.component';
import {ItemPricingFormComponent} from './Components/admin/item-pricing/item-pricing-form/item-pricing-form.component';
import {ItemCategoryFormComponent} from './Components/admin/item-category/item-category-form/item-category-form.component';
import {EntityTypeFormComponent} from './Components/admin/entity-type/entity-type-form/entity-type-form.component';
import {ItemTypeFormComponent} from './Components/admin/item-type/item-type-form/item-type-form.component';
import {ItemTypeListComponent} from './Components/admin/item-type/item-type-list/item-type-list.component';
import {ItemGroupFormComponent} from './Components/admin/item-group/item-group-form/item-group-form.component';
import {ItemGroupListComponent} from './Components/admin/item-group/item-group-list/item-group-list.component';

// entity report
import {EntityHistoryReportComponent} from './Components/Reports/entity/entity-history-report/entity-history-report.component';
import {EmployeeFormComponent} from './Components/payroll/employee-form/employee-form.component';
import {EmployeeListComponent} from './Components/payroll/employee-list/employee-list.component';
import {DepartmentListComponent} from './Components/payroll/department-list/department-list.component';
import {DepartmentFormComponent} from './Components/payroll/department-form/department-form.component';
import {EmployeeTypeListComponent} from './Components/payroll/employee-type-list/employee-type-list.component';
import {EmployeeTypeFormComponent} from './Components/payroll/employee-type-form/employee-type-form.component';
import {ProviderConfigComponent} from './Components/payroll/provider-config/provider-config.component';
import {GustoDashboardComponent} from './Components/payroll/gusto-dashboard/gusto-dashboard.component';
import {StripeDashboardComponent} from './Components/stripe-dashboard/stripe-dashboard.component';
import {ArDashboardComponent} from './Components/ar-dashboard/ar-dashboard.component';
import {ApDashboardComponent} from './Components/ap-dashboard/ap-dashboard.component';
import {CrmDashboardComponent} from './Components/crm/crm-dashboard/crm-dashboard.component';
import {CrmCustomerListComponent} from './Components/crm/crm-customer-list/crm-customer-list.component';
import {CrmCustomerDetailComponent} from './Components/crm/crm-customer-detail/crm-customer-detail.component';
import {CrmPipelineComponent} from './Components/crm/crm-pipeline/crm-pipeline.component';
import {CrmInteractionsComponent} from './Components/crm/crm-interactions/crm-interactions.component';
import {CrmOpportunitiesComponent} from './Components/crm/crm-opportunities/crm-opportunities.component';
import {CrmOpportunityDetailComponent} from './Components/crm/crm-opportunity-detail/crm-opportunity-detail.component';
import {OnboardComponent} from './Components/onboard/onboard.component';

// pos
import {PosDataBrowserListComponent} from './Components/pos/pos-data-browser-list/pos-data-browser-list.component';

// shipping
import {ShipmentListComponent} from './Components/transactions/shipment-list/shipment-list.component';
import {ShipmentFormComponent} from './Components/transactions/shipment-form/shipment-form.component';

// 404
import {Error400PageComponent} from './Components/common/error400-page/error400-page.component';
import {NotAuthorizedPageComponent} from './Components/common/not-authorized-page/not-authorized-page.component';
import {PermissionGuard} from './Guards/permission.guard';

// workorder report
import {WorkorderReportComponent} from './Components/Reports/activity/reports/workorder-report/workorder-report.component';
import {Error500PageComponent} from './Components/common/error500-page/error500-page.component';

// reset pw
// OLD import {ResetPasswordComponent} from './Components/reset-password/reset-password.component';
import {PasswordResetComponent} from './Components/password-reset/password-reset.component';

import {VerifyEmailComponent} from './Components/verify-email/verify-email.component';

// printing docs
import { PrintLayoutComponent} from './Layouts/print-layout.component';
import {PrintTransactionDocument} from './Components/transactions/print-transaction-document/print-transaction-document';

// fixed assets
import {FixedAssetConfigComponent} from './Components/admin/fixed-assets/fixed-asset-config/fixed-asset-config.component';
import {AdminOperationsComponent} from './Components/admin/admin-operations/admin-operations.component';
import {FixedAssetListComponent} from './Components/fixed-assets/fixed-asset-list/fixed-asset-list.component';
import {FixedAssetFormComponent} from './Components/fixed-assets/fixed-asset-form/fixed-asset-form.component';

// fixed assets reports
import {DisposalsReportComponent} from './Components/Reports/fixed-assets/disposals/disposals.component';
import {DepreciationScheduleReportComponent} from './Components/Reports/fixed-assets/depreciation-schedule/depreciation-schedule.component';
import {AssetRegisterComponent} from './Components/Reports/fixed-assets/asset-register/asset-register.component';
import {FixedAssetGlEntriesComponent} from './Components/Reports/fixed-assets/gl-entries/gl-entries.component';
import {ChatThreadComponent} from './Components/common/chat/chat-thread/chat-thread.component';
// AssetDepreciationReportComponent removed (no longer routed)

// project management
import {ProjectDashboardComponent} from './Components/projects/project-dashboard/project-dashboard.component';
// project reports
import {ProjectStatusReportComponent} from './Components/Reports/projects/project-status-report/project-status-report.component';
import {CrmPipelineReportComponent} from './Components/Reports/crm/crm-pipeline-report/crm-pipeline-report.component';
import {CrmWonLostReportComponent} from './Components/Reports/crm/crm-won-lost-report/crm-won-lost-report.component';
import {CrmActivityReportComponent} from './Components/Reports/crm/crm-activity-report/crm-activity-report.component';
import {JournalEntryReportComponent} from './Components/Reports/ledger/journal-entry-report/journal-entry-report.component';
import {
  CrmOpportunityDetailReportComponent
} from './Components/Reports/crm/crm-opportunity-detail-report/crm-opportunity-detail-report.component';
import {CrmFollowUpReportComponent} from './Components/Reports/crm/crm-followup-report/crm-followup-report.component';
import {CrmPipelineAgingReportComponent} from './Components/Reports/crm/crm-pipeline-aging-report/crm-pipeline-aging-report.component';
import {OverBudgetTasksReportComponent} from './Components/Reports/projects/over-budget-tasks-report/over-budget-tasks-report.component';
import {ProjectDetailReportComponent} from './Components/Reports/projects/project-detail-report/project-detail-report.component';
import {ProjectTimeReportComponent} from './Components/Reports/projects/project-time-report/project-time-report.component';
import {
  ProjectProfitabilityReportComponent
} from './Components/Reports/projects/project-profitability-report/project-profitability-report.component';
import {ProjectMilestoneReportComponent} from './Components/Reports/projects/project-milestone-report/project-milestone-report.component';
import {ProjectListComponent} from './Components/projects/project-list/project-list.component';
import {ProjectFormComponent} from './Components/projects/project-form/project-form.component';
import {ProjectDetailComponent} from './Components/projects/project-detail/project-detail.component';
import {PmUserBillingRateListComponent} from './Components/projects/settings/pm-user-billing-rate-list/pm-user-billing-rate-list.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AppLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      // config - prefs stuff
      {path: 'home', component: HomeComponent},
      {path: 'schedule', component: CalendarComponent},
      {path: 'dashboards/ar', component: ArDashboardComponent, canActivate: [PermissionGuard], data: {permission: 'DashboardAR'}},
      {path: 'dashboards/ap', component: ApDashboardComponent, canActivate: [PermissionGuard], data: {permission: 'DashboardAP'}},
      // CRM
      {path: 'crm', component: CrmDashboardComponent, canActivate: [PermissionGuard], data: {permission: 'DashboardCRM'}},
      {path: 'crm/entities', component: CrmCustomerListComponent, canActivate: [PermissionGuard], data: {permission: 'ViewCRMEntities'}},
      {
        path: 'crm/entities/:id',
        component: CrmCustomerDetailComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewCRMEntities'}
      },
      {path: 'crm/customers', component: CrmCustomerListComponent, canActivate: [PermissionGuard], data: {permission: 'ViewCRMEntities'}},
      {
        path: 'crm/customers/:id',
        component: CrmCustomerDetailComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewCRMEntities'}
      },
      {path: 'crm/pipeline', component: CrmPipelineComponent, canActivate: [PermissionGuard], data: {permission: 'ViewLeads'}},
      {path: 'crm/interactions', component: CrmInteractionsComponent, canActivate: [PermissionGuard], data: {permission: 'ViewLeads'}},
      {path: 'crm/opportunities', component: CrmOpportunitiesComponent, canActivate: [PermissionGuard], data: {permission: 'ViewLeads'}},
      {
        path: 'crm/opportunities/:id',
        component: CrmOpportunityDetailComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewLeads'}
      },
      {path: 'dashboards/onboard', component: OnboardComponent},
      {path: 'chat', component: ChatThreadComponent},
      {path: 'chat/:threadId', component: ChatThreadComponent},
      {path: 'entity-list', component: EntityListComponent},
      // invoice variants
      // {path: 'transactions/invoice/list/ar:type=shipments', component: InvoiceListComponent},
      {
        path: 'transactions/invoice/list/ar-refactor',
        component: InvoiceListArComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewReceivableInvoices'}
      },
      {
        path: 'transactions/invoice/list/ar',
        component: InvoiceListArComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewReceivableInvoices'}
      },
      {
        path: 'transactions/invoice/list/ap-refactor',
        component: InvoiceListApComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewPayableInvoices'}
      },
      {
        path: 'transactions/invoice/list/so-refactor',
        component: InvoiceListSoComponent,
      },
      {
        path: 'transactions/invoice/list/po-refactor',
        component: InvoiceListPoComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewSalesOrders'}
      },
      {
        path: 'transactions/invoice/list/quote-refactor',
        component: InvoiceListQuoteComponent,
      },
      {
        path: 'transactions/invoice/list/ap',
        component: InvoiceListApComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewPayableInvoices'}
      },
      {
        path: 'transactions/invoice/list/purchaseorders',
        component: InvoiceListPoComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewPayableInvoices'}
      },
      {
        path: 'transactions/invoice/list/salesorders',
        component: InvoiceListSoComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewReceivableInvoices'}
      },
      {
        path: 'transactions/invoice/list/quotes',
        component: InvoiceListQuoteComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewReceivableInvoices'}
      },
      // {
      //   path: 'transactions/shipments/list',
      //   component: ShipmentListComponent,
      //   canActivate: [PermissionGuard],
      //   data: {permission: 'ViewReceivableInvoices'}
      // },
      {path: 'admin/bank-list', component: BankListComponent},
      {path: 'admin/salesperson-list', component: SalespersonListComponent},
      {path: 'admin/check-stock-list', component: CheckStockListComponent},
      {path: 'admin/currency-rate-list', component: CurrencyRateListComponent},
      {path: 'entity-access-list', component: EntityAccessListComponent},
      {path: 'admin/location-group-list', component: LocationGroupListComponent},
      {path: 'admin/payment-type-list', component: PaymentTypeListComponent},
      {path: 'admin/stripe-admin-list', component: StripeAdminListComponent},
      {path: 'admin/tax-list', component: TaxListComponent},
      {path: 'admin/tax-rate-list', component: TaxRateListComponent},
      {path: 'admin/term-list', component: TermListComponent},
      {path: 'assembly-list', component: AssemblyListComponent },
      {path: 'admin/bom-list', component: BomListComponent },
      {path: 'transfer-list', component: TransferListComponent },
      {path: 'admin/item-list', component: ItemListComponent},
      {path: 'admin/item-category-list', component: ItemCategoryListComponent},
      {path: 'admin/item-type-list', component: ItemTypeListComponent},
      {
        path: 'admin/item-type-form',
        component: ItemTypeFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'admin/item-group-list', component: ItemGroupListComponent},
      {
        path: 'admin/item-group-form',
        component: ItemGroupFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'password-reset', component: PasswordResetComponent},
      {path: 'admin/location-list', component: LocationListComponent},
      {path: 'admin/company-list', component: CompanyListComponent},
      {path: 'admin/company-access-list', component: CompanyAccessListComponent},
      {path: 'admin/currency-list', component: CurrencyListComponent},
      {path: 'admin/account-list', component: AccountListComponent},
      {path: 'admin/account-import', component: AccountImportComponent},
      {path: 'transactions/entry/import', component: GlImportComponent},
      {path: 'admin/account-margin-list', component: AccountMarginListComponent},
      {path: 'admin/account-subtotal-list', component: AccountSubtotalListComponent},
      {path: 'admin/entity-type-list', component: EntityTypeListComponent},
      {path: 'admin/check-stock-list', component: CheckStockListComponent},
      {path: 'admin/currency-rate-list', component: CurrencyRateListComponent},
      {path: 'admin/entity-access-list', component: EntityAccessListComponent},
      {path: 'admin/location-group-list', component: LocationGroupListComponent},
      {path: 'admin/location-access-list', component: LocationAccessListComponent},
      {path: 'admin/payment-type-list', component: PaymentTypeListComponent},
      {path: 'admin/stripe-admin-list', component: StripeAdminListComponent},
      {path: 'admin/tax-list', component: TaxListComponent},
      {path: 'admin/tax-rate-list', component: TaxRateListComponent},
      {path: 'admin/term-list', component: TermListComponent},
      {path: 'admin/uom-list', component: UomListComponent},
      {path: 'admin/item-pricing-list', component: ItemPricingListComponent},
      {path: 'admin/reporting-field-type-list', component: ReportingFieldTypeListComponent},
      // transaction-reports
      {
        path: 'transaction-reports/balance-sheet',
        component: BalanceSheetComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'BalanceSheet'}
      },
      {
        path: 'transaction-reports/consolidated-income-statement',
        component: ConsolidatedIncomeStatementComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'IncomeStatement'}
      },
      {
        path: 'transaction-reports/margin-report',
        component: MarginReportComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'MarginReport'}
      },
      {
        path: 'transaction-reports/trial-balance',
        component: TrialBalanceComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'TrialBalance'}
      },
      {
        path: 'transaction-reports/transaction-detail',
        component: TransactionDetailComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'TransactionDetail'}
      },
      {path: 'transaction-reports/aging/ap', component: AgingComponent, canActivate: [PermissionGuard], data: {permission: 'PayableAging'}},
      {
        path: 'transaction-reports/aging/ar',
        component: AgingComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ReceivableAging'}
      },
      {
        path: 'transaction-reports/aging/:subLedger',
        component: AgingComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ReceivableAging'}
      },
      {
        path: 'transaction-reports/invoices/ap',
        component: InvoicesComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'PayableInvoices'}
      },
      {
        path: 'transaction-reports/invoices/ar',
        component: InvoicesComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ReceivableInvoices'}
      },
      {
        path: 'transaction-reports/invoices/ss',
        component: InvoicesComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ReceivableInvoices'}
      },
      {
        path: 'transaction-reports/invoices/sq',
        component: InvoicesComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ReceivableInvoices'}
      },
      {
        path: 'transaction-reports/invoices/ps',
        component: InvoicesComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'PayableInvoices'}
      },
      {
        path: 'transaction-reports/invoices/so',
        component: InvoicesComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ReceivableInvoices'}
      },
      {
        path: 'transaction-reports/invoices/po',
        component: InvoicesComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'PayableInvoices'}
      },
      {
        path: 'transaction-reports/payments/ap',
        component: PaymentsComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'PayablePayments'}
      },
      {
        path: 'transaction-reports/payments/ar',
        component: PaymentsComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ReceivablePayments'}
      },
      {
        path: 'transaction-reports/stripe-transaction-detail',
        component: StripeTransactionDetailComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'DashboardStripe'}
      },
      {
        path: 'transaction-reports/check-register',
        component: CheckRegisterComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'PayablePayments'}
      },
      {
        path: 'transaction-reports/statements',
        component: StatementsComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ReceivableStatements'}
      },
      {path: 'transaction-reports/tax', component: TaxComponent, canActivate: [PermissionGuard], data: {permission: 'PayableTaxes'}},
      {
        path: 'transaction-reports/entity-reconciliation/:subLedger',
        component: EntityReconciliationComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ReceivableReconciliation'}
      },
      {
        path: 'transaction-reports/cash-flow',
        component: CashFlowComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'IncomeStatement'}
      },
      {
        path: 'activity/transaction-reports/workorder-report',
        component: WorkorderReportComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'WorkOrdersReport'}
      },
      {
        path: 'transaction-reports/income-statement',
        component: IncomeStatementComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'IncomeStatement'}
      },
      // inventory transaction-reports
      {
        path: 'inventory/transaction-reports/assembly',
        component: AssemblyReportComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'AssembliesReport'}
      },
      {
        path: 'inventory/transaction-reports/balance',
        component: BalanceReportComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ItemBalancesReport'}
      },
      {
        path: 'inventory/transaction-reports/count',
        component: CountReportComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'CountsReport'}
      },
      {
        path: 'inventory/transaction-reports/transfer',
        component: TransferReportComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'TransfersReport'}
      },
      // payroll transaction-reports
      {
        path: 'payroll/transaction-reports/employee-detail',
        component: EmployeeDetailReportComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'Payroll'}
      },
      // entity report
      {
        path: 'transaction-reports/entity-history-report',
        component: EntityHistoryReportComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'TransactionDetail'}
      },
      // Transactions
      {
        path: 'transactions/payment/list/ar',
        component: PaymentListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewReceivablePayments'}
      },
      {
        path: 'transactions/payment/list/ap',
        component: PaymentListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewPayablePayments'}
      },
      {
        path: 'transactions/issue-payments',
        component: IssuePaymentsComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewPayablePayments'}
      },
      // {path: 'transactions/invoice/recurring/:type', component: InvoiceRecurringListComponent},
      {path: 'transactions/invoice/recurring/ar', component: InvoiceRecurringListComponent},
      {path: 'transactions/invoice/recurring/ap', component: InvoiceRecurringListComponent},

      {
        path: 'transactions/bank-import',
        component: BankImportPageComponent,
        canActivate: [AuthGuard, PermissionGuard], data: {permission: 'BankImport'}
      },
      {
        path: 'transactions/bank-import/wizard',
        component: BankImportWizardComponent,
        canActivate: [AuthGuard, PermissionGuard], data: {permission: 'BankImport'}
      },
      {
        path: 'transactions/bank-import/history',
        component: BankImportHistoryComponent,
        canActivate: [AuthGuard, PermissionGuard], data: {permission: 'BankImport'}
      },
      {
        path: 'transactions/bank-reconciliation/bank-reconciliation-list',
        component: BankReconciliationListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'BankReconciliation'}
      },
      {path: 'transactions/shipment/list/ar', component: ShipmentListComponent},
      {path: 'transactions/shipment/list/ap', component: ShipmentListComponent},
      // Reporting Field
      {path: 'admin/reporting-field-list', component: ReportingFieldListComponent},
      // Work Orders
      {
        path: 'work-orders/work-orders-list',
        component: WorkOrdersListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/billing',
        component: WorkOrdersBillingComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/dashboard',
        component: WorkOrdersDashboardComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/schedule',
        component: WorkOrdersScheduleComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/assets/asset-list',
        component: AssetListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/assets/asset-form',
        component: AssetFormComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/assets/asset-detail',
        component: AssetDetailComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/pm-schedules/pm-schedule-list',
        component: PmScheduleListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/pm-schedules/pm-schedule-form',
        component: PmScheduleFormComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/settings/wo-type-list',
        component: WoTypeListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/settings/wo-category-list',
        component: WoCategoryListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/settings/wo-user-billing-rate-list',
        component: WoUserBillingRateListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      {
        path: 'work-orders/settings/checklist-template-list',
        component: ChecklistTemplateListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewWorkOrders'}
      },
      // Time sheet
      {
        path: 'timesheet/timesheet-list',
        component: TimesheetListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewTimeSheets'}
      },
      {
        path: 'timesheet/timesheet-approval-list',
        component: TimesheetApprovalListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewTimeSheets'}
      },
      // Sys-User
      {path: 'admin/sys-user/list', component: SysUserListComponent, canActivate: [PermissionGuard], data: {permission: 'SetupUsers'}},
      {path: 'Calendar/:currentUserId', component: CalendarComponent},
      // Ledger
      {
        path: 'transactions/entry/list',
        component: EntryListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewJournalEntries'}
      },
      {path: 'transactions/entry/recurring', component: EntryRecurringComponent},
      {
        path: 'transactions/statistical/list',
        component: StatisticalListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewJournalEntries'}
      },
      {
        path: 'transactions/statistical/form',
        component: StatisticalFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'transactions/statistical/recurring-list', component: StatisticalRecurringListComponent},
      // Inventory
      {
        path: 'inventory/dashboard',
        component: InventoryDashboardComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'Inventory'}
      },
      {path: 'inventory/assemble/list', component: AssemblyListComponent, canActivate: [PermissionGuard], data: {permission: 'Inventory'}},
      {path: 'inventory/transfer/list', component: TransferListComponent, canActivate: [PermissionGuard], data: {permission: 'Inventory'}},
      {path: 'inventory/count/list', component: CountListComponent, canActivate: [PermissionGuard], data: {permission: 'Inventory'}},
      {
        path: 'inventory/bill-of-materials/bom-list',
        component: BomListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'Inventory'}
      },
      // Project Management
      {path: 'projects/project-dashboard', component: ProjectDashboardComponent},
      {path: 'projects/project-list', component: ProjectListComponent},
      {path: 'projects/project-detail', component: ProjectDetailComponent},
      {path: 'projects/settings/pm-user-billing-rate-list', component: PmUserBillingRateListComponent},
      {path: 'projects/reports/project-status', component: ProjectStatusReportComponent},
      {path: 'projects/reports/over-budget-tasks', component: OverBudgetTasksReportComponent},
      {path: 'projects/reports/project-detail', component: ProjectDetailReportComponent},
      {path: 'projects/reports/project-time', component: ProjectTimeReportComponent},
      {path: 'projects/reports/project-profitability', component: ProjectProfitabilityReportComponent},
      {path: 'projects/reports/project-milestone', component: ProjectMilestoneReportComponent},
      // CRM reports
      {path: 'crm/reports/pipeline', component: CrmPipelineReportComponent},
      {path: 'crm/reports/won-lost', component: CrmWonLostReportComponent},
      {path: 'crm/reports/activity', component: CrmActivityReportComponent},
      {path: 'ledger/reports/journal-entry', component: JournalEntryReportComponent},
      {path: 'crm/reports/opportunity-detail', component: CrmOpportunityDetailReportComponent},
      {path: 'crm/reports/followup', component: CrmFollowUpReportComponent},
      {path: 'crm/reports/pipeline-aging', component: CrmPipelineAgingReportComponent},
      // Payroll
      {path: 'payroll/employee-list', component: EmployeeListComponent, canActivate: [PermissionGuard], data: {permission: 'Payroll'}},
      {path: 'payroll/department-list', component: DepartmentListComponent},
      {path: 'payroll/department-form', component: DepartmentFormComponent},
      {path: 'payroll/employee-type-list', component: EmployeeTypeListComponent},
      {path: 'payroll/employee-type-form', component: EmployeeTypeFormComponent},
      {path: 'payroll/provider-config', component: ProviderConfigComponent},
      {
        path: 'payroll/gusto-dashboard',
        component: GustoDashboardComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'DashboardGusto'}
      },
      {
        path: 'stripe/dashboard',
        component: StripeDashboardComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'DashboardStripe'}
      },
      // pos
      {path: 'pos/pos-data-browser-list/pos-data-browser-list', component: PosDataBrowserListComponent},
      // audit trail
      {
        path: 'admin/audit-trail-viewer-form',
        component: AuditTrailViewerFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
    ]
  },
  {
    path: '',
    component: TransactionLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      // admin forms
      {path: 'entity-form', component: EntityFormComponent},
      {path: 'admin/bank-form', component: BankFormComponent, canDeactivate: [UnsavedChangesGuard]},
      {path: 'admin/budget-list', component: BudgetListComponent, canActivate: [PermissionGuard], data: {permission: 'ViewBudget'}},
      {path: 'admin/budget-form', component: BudgetFormComponent, canDeactivate: [UnsavedChangesGuard], runGuardsAndResolvers: 'always'},
      {
        path: 'admin/check-stock-form',
        component: CheckStockFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/currency-rate-form',
        component: CurrencyRateFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'entity-access-form',
        component: EntityAccessFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/location-group-form',
        component: LocationGroupFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/payment-type-form',
        component: PaymentTypeFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      // Unified Stripe Admin Form (single component for AR/AP). Keep a single pair of routes.
      {
        path: 'admin/stripe-admin-form',
        component: StripeAdminFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/stripe-admin-form/:id',
        component: StripeAdminFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'admin/tax-form', component: TaxFormComponent, canDeactivate: [UnsavedChangesGuard], runGuardsAndResolvers: 'always'},
      {path: 'admin/tax-rate-form', component: TaxRateFormComponent, canDeactivate: [UnsavedChangesGuard], runGuardsAndResolvers: 'always'},
      {path: 'admin/term-form', component: TermFormComponent, canDeactivate: [UnsavedChangesGuard], runGuardsAndResolvers: 'always'},
      {path: 'assembly-form', component: AssemblyFormComponent },
      {path: 'admin/bom-form', component: BomFormComponent },
      {path: 'transfer-form', component: TransferFormComponent },
      {path: 'admin/item-form', component: ItemFormComponent, canDeactivate: [UnsavedChangesGuard], runGuardsAndResolvers: 'always'},
      {
        path: 'admin/item-category-form',
        component: ItemCategoryFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'password-reset', component: PasswordResetComponent},
      {
        path: 'admin/location-form',
        component: LocationFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'admin/company-form', component: CompanyFormComponent, canDeactivate: [UnsavedChangesGuard]},
      {path: 'admin/company-access-form', component: CompanyAccessFormComponent, canDeactivate: [UnsavedChangesGuard]},
      {
        path: 'admin/currency-form',
        component: CurrencyFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'admin/account-form', component: AccountFormComponent},
      {
        path: 'admin/account-margin-form',
        component: AccountMarginFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/account-subtotal-form',
        component: AccountSubtotalFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'admin/entity-type-form', component: EntityTypeFormComponent, canDeactivate: [UnsavedChangesGuard]},
      {
        path: 'admin/check-stock-form',
        component: CheckStockFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/currency-rate-form',
        component: CurrencyRateFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/entity-access-form',
        component: EntityAccessFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/location-group-form',
        component: LocationGroupFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/location-access-form',
        component: LocationAccessFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/payment-type-form',
        component: PaymentTypeFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'admin/tax-form', component: TaxFormComponent, canDeactivate: [UnsavedChangesGuard], runGuardsAndResolvers: 'always'},
      {path: 'admin/tax-rate-form', component: TaxRateFormComponent, canDeactivate: [UnsavedChangesGuard], runGuardsAndResolvers: 'always'},
      {path: 'admin/term-form', component: TermFormComponent, canDeactivate: [UnsavedChangesGuard], runGuardsAndResolvers: 'always'},
      {path: 'admin/uom-form', component: UomFormComponent, canDeactivate: [UnsavedChangesGuard], runGuardsAndResolvers: 'always'},
      {
        path: 'admin/item-pricing-form',
        component: ItemPricingFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/salesperson-form',
        component: SalespersonFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/reporting-field-type-form',
        component: ReportingFieldTypeFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'admin/fixed-assets/fixed-assets-config',
        component: FixedAssetConfigComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'fixed-assets/fixed-asset-list',
        component: FixedAssetListComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewFixedAssets'}
      },
      // support both explicit form path and id-based route for edit/new
      {
        path: 'fixed-assets/fixed-asset-form',
        component: FixedAssetFormComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewFixedAssets'}
      },
      {
        path: 'fixed-assets/fixed-asset-form/:id',
        component: FixedAssetFormComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewFixedAssets'}
      },
      {
        path: 'Reports/fixed-assets/disposals-report',
        component: DisposalsReportComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'FixedAssetDisposalReport'}
      },
      {
        path: 'Reports/fixed-assets/depreciation-schedule-report',
        component: DepreciationScheduleReportComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'DepreciationScheduleReport'}
      },
      {
        path: 'Reports/fixed-assets/asset-register',
        component: AssetRegisterComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'FixedAssetListReport'}
      },
      {
        path: 'Reports/fixed-assets/gl-entries',
        component: FixedAssetGlEntriesComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewFixedAssets'}
      },

      // Transactions
      {
        path: 'transactions/payment/form',
        component: PaymentFormComponent,
        canActivate: [PermissionGuard], data: {permission: 'ViewReceivablePayments'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      // Phase 6 — REFACTOR: AR Invoice extracted component (side-by-side testing)
      {
        path: 'transactions/invoice/ap/form',
        component: InvoiceFormApComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewPayableInvoices'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'transactions/invoice/so/form',
        component: InvoiceFormSoComponent,
      },
      {
        path: 'transactions/invoice/po/form',
        component: InvoiceFormPoComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'ViewPayableInvoices'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'transactions/invoice/quote/form',
        component: InvoiceFormQuotePageComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'transactions/invoice/ar/form',
        component: InvoiceFormArComponent,
        canActivate: [PermissionGuard], data: {permission: 'ViewReceivableInvoices'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      // {path: 'transactions/invoice/recurring/ar:type', component: InvoiceRecurringListComponent},
      // {path: 'transactions/invoice/recurring/ap:type', component: InvoiceRecurringListComponent},
      {
        path: 'transactions/shipment/form',
        component: ShipmentFormComponent,
        canActivate: [PermissionGuard], data: {permission: 'ViewReceivableInvoices'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'transactions/statistical/form',
        component: StatisticalFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      // Reporting Field
      {
        path: 'admin/reporting-field-form',
        component: ReportingFieldFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      // Workorder
      {
        path: 'work-orders/work-orders-form',
        component: WorkOrdersFormComponent,
        canActivate: [PermissionGuard], data: {permission: 'ViewWorkOrders'},
      },
      // Timesheet
      {
        path: 'timesheet/timesheet-form',
        component: TimesheetFormComponent,
        canActivate: [PermissionGuard], data: {permission: 'ViewTimeSheets'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'timesheet/timesheet-approval-form',
        component: TimesheetApprovalFormComponent,
        canActivate: [PermissionGuard], data: {permission: 'ViewTimeSheets'},
        runGuardsAndResolvers: 'always'
      },
      // Sys-User
      {
        path: 'admin/sys-user-form',
        component: SysUserFormComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'SetupUsers'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'admin/user-profile', component: UserProfileComponent, runGuardsAndResolvers: 'always'},
      {
        path: 'admin/operations',
        component: AdminOperationsComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'Admin'},
        runGuardsAndResolvers: 'always'
      },
      // Ledger
      {
        path: 'transactions/bank-reconciliation/bank-reconciliation-form',
        component: BankReconciliationFormComponent,
        canActivate: [PermissionGuard], data: {permission: 'BankReconciliation'},
        canDeactivate: [UnsavedChangesGuard]
      },
      {
        path: 'transactions/entry/form',
        component: EntryFormComponent,
        canActivate: [PermissionGuard], data: {permission: 'ViewJournalEntries'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {path: 'transactions/entry/recurring', component: EntryRecurringComponent},
      {
        path: 'transactions/statistical/form',
        component: StatisticalFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      // Inventory
      {
        path: 'inventory/assemble/form',
        component: AssemblyFormComponent,
        canActivate: [PermissionGuard], data: {permission: 'Inventory'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'inventory/transfer/form',
        component: TransferFormComponent,
        canActivate: [PermissionGuard], data: {permission: 'Inventory'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'inventory/count/form',
        component: CountFormComponent,
        canActivate: [PermissionGuard],
        data: {permission: 'Inventory'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      {
        path: 'inventory/bill-of-materials/bom-form',
        component: BomFormComponent,
        canActivate: [PermissionGuard], data: {permission: 'Inventory'},
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      // Project Management
      {
        path: 'projects/project-form',
        component: ProjectFormComponent,
        canDeactivate: [UnsavedChangesGuard],
        runGuardsAndResolvers: 'always'
      },
      // Payroll
      {path: 'payroll/employee-form', component: EmployeeFormComponent, canActivate: [PermissionGuard], data: {permission: 'Payroll'}},
    ]
  },
  {
    path: '',
    component: PrintLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    // runs all doc prints - not transaction-reports - through this wrapper - add docs as children
    path: '',
    component: PrintLayoutComponent,
    canActivateChild: [AuthGuard],
    // outlet: 'print',
    children: [
      { path: 'transactions/invoice-print-ar', component: PrintTransactionDocument }
    ]
  },
  {
    path: '',
    component: LoginLayoutComponent,
    canActivate: [AuthGuard]
  },
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {path: 'login', component: LoginComponent},
      {path: 'forgot-password', component: ForgotPasswordComponent},
      {path: 'verify-email', component: VerifyEmailComponent},
      {path: 'common/error500-page', component: Error500PageComponent},
      {path: 'common/not-authorized-page', component: NotAuthorizedPageComponent},
      {path: 'common/error404-page', component: Error400PageComponent},
    ]
  },

  // 404
  { path: '**', component: Error400PageComponent },


];

@NgModule({
  // imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top',
    enableTracing: false,
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
